import { APP_CONSTANTS } from 'app/constants/app-constants';
//import * as RiIcons from 'react-icons/ri';
import customerIcon from 'assets/images/customerMangement.svg';
import userIcon from 'assets/images/ic-contact-browser.svg';
import StoreIcon from 'assets/images/ic-ecommerce-delivery.svg';
import MallIcon from 'assets/images/ic-places-cinema.svg';
//const user = JSON.parse(LocalStorage.get(LocalSessionKey.USER_INFO));

const SideMenuData = [
  {
    title: 'Bill Validation',
    id: APP_CONSTANTS.BILL_VALIDATION_TAG,
    to: APP_CONSTANTS.BILL_VALIDATION,
    active: false,
    key: APP_CONSTANTS.Bill_Validation_Key,
    icon: userIcon,
  },
  {
    title: 'Customer Management',
    id: APP_CONSTANTS.CUSTOMER_MANAGEMENT_TAG,
    to: APP_CONSTANTS.CUSTOMER_MANAGEMENT,
    active: false,
    key: APP_CONSTANTS.Customer_Management_Key,
    icon: customerIcon,
  },
  {
    title: 'Collection Panel',
    id: APP_CONSTANTS.CUSTOMER_MANAGEMENT_TAG,
    to: APP_CONSTANTS.COLLECTION_PANEL,
    active: false,
    key: APP_CONSTANTS.Customer_Management_Key,
    icon: userIcon,
  },
  {
    title: 'Tier Management',
    id: APP_CONSTANTS.TIER_TAG,
    to: APP_CONSTANTS.TIER,
    active: false,
    key: APP_CONSTANTS.Tier_Management_Key,
    icon: MallIcon,
  },
  {
    title: 'Mall Management',
    icon: MallIcon,
    id: APP_CONSTANTS.MALL_TAG,
    to: APP_CONSTANTS.MALL,
    active: false,
    key: APP_CONSTANTS.Mall_Information_Management_Key,
  },
  {
    title: 'Banner',
    id: APP_CONSTANTS.MALL_BANNER_TAG,
    to: APP_CONSTANTS.MALL_BANNER,
    active: false,
    key: APP_CONSTANTS.Mall_Banner_Key,
    icon: MallIcon,
  },
  // {
  //   title: 'Mall Management',
  //   id: APP_CONSTANTS.MALL_TAG,
  //   active: false,
  //   key: APP_CONSTANTS.Mall_Information_Management_Key,
  //   icon: MallIcon,
  //   iconClosed: <RiIcons.RiArrowDownSFill />,
  //   iconOpened: <RiIcons.RiArrowUpSFill />,
  //   subNav:
  //     user?.type === 'su'
  //       ? [
  //           {
  //             title: 'Mall',
  //             id: APP_CONSTANTS.MALL_TAG,
  //             to: APP_CONSTANTS.MALL,
  //             active: false,
  //             key: APP_CONSTANTS.Mall_Information_Management_Key,
  //           },
  //           {
  //             title: 'Banner',
  //             id: APP_CONSTANTS.MALL_BANNER_TAG,
  //             to: APP_CONSTANTS.MALL_BANNER,
  //             active: false,
  //             key: APP_CONSTANTS.Mall_Information_Management_Key,
  //           },
  //         ]
  //       : [
  //           {
  //             title: 'Mall',
  //             id: APP_CONSTANTS.MALL_TAG,
  //             to: APP_CONSTANTS.MALL,
  //             active: false,
  //             key: APP_CONSTANTS.Mall_Information_Management_Key,
  //           },
  //         ],
  // },
  {
    title: 'Support Service',
    id: APP_CONSTANTS.SUPPORT_SERVICE_TAG,
    to: APP_CONSTANTS.SUPPORT_SERVICE,
    active: false,
    key: APP_CONSTANTS.Support_Service_Key,
    icon: StoreIcon,
  },
  {
    title: 'Store Management',
    id: APP_CONSTANTS.STORE_TAG,
    to: APP_CONSTANTS.STORE,
    active: false,
    key: APP_CONSTANTS.Store_Management_Key,
    icon: StoreIcon,
  },
  {
    title: 'Event Management',
    id: APP_CONSTANTS.EVENT_TAG,
    to: APP_CONSTANTS.EVENT,
    active: false,
    key: APP_CONSTANTS.Event_Management_Key,
    icon: userIcon,
  },
  // Game Management — HIDDEN for the production release (06-Jul-26, user
  // decision). The module, routes, and backend stay fully functional;
  // uncomment this entry to bring it back in the sidebar.
  {
    title: 'Game Management',
    id: APP_CONSTANTS.GAME_MANAGEMENT_TAG,
    to: APP_CONSTANTS.GAME_MANAGEMENT,
    active: false,
    key: APP_CONSTANTS.Games_Management_Key,
    icon: userIcon,
  },

  {
    title: 'Voucher Management',
    id: APP_CONSTANTS.VOUCHER_TAG,
    to: APP_CONSTANTS.VOUCHER,
    active: false,
    key: APP_CONSTANTS.Voucher_or_Rewards_Management_Key,
    icon: userIcon,
  },
  {
    title: 'Cancel Voucher',
    id: APP_CONSTANTS.CANCEL_VOUCHER_TAG,
    to: APP_CONSTANTS.CANCEL_VOUCHER,
    active: false,
    key: APP_CONSTANTS.Cancel_voucher_key,
    icon: userIcon,
  },
  {
    title: 'Offer Management',
    id: APP_CONSTANTS.OFFER_DEALS_TAG,
    to: APP_CONSTANTS.OFFER_DEALS,
    active: false,
    key: APP_CONSTANTS.Deals_Offers_Management_Key,
    icon: userIcon,
  },
  {
    title: APP_CONSTANTS.NOTIFICATION_TAG,
    id: APP_CONSTANTS.NOTIFICATION_TAG,
    to: APP_CONSTANTS.NOTIFICATION,
    active: false,
    key: APP_CONSTANTS.Notification_Panel_Key,
    icon: userIcon,
  },

  {
    title: 'Feedback Management',
    id: APP_CONSTANTS.FEEDBACK_MANAGEMENT_TAG,
    to: APP_CONSTANTS.FEEDBACK_MANAGEMENT,
    active: false,
    key: APP_CONSTANTS.Feedback_Management_Key,
    icon: userIcon,
  },
  {
    title: 'User Management',
    id: APP_CONSTANTS.USERS_TAG,
    to: APP_CONSTANTS.USERS,
    active: false,
    key: APP_CONSTANTS.User_Management_Key,
    icon: userIcon,
  },
  {
    title: 'Reports',
    id: APP_CONSTANTS.REPORTS_TAG,
    to: APP_CONSTANTS.REPORTS,
    active: false,
    key: APP_CONSTANTS.Analytics_and_Reporting_Key,
    icon: userIcon,
  },
  {
    title: 'Reports',
    id: APP_CONSTANTS.REPORTS_TAG,
    to: APP_CONSTANTS.REPORTS,
    active: false,
    key: APP_CONSTANTS.REPORTS_TAG,
    icon: userIcon,
  },
  {
    title: 'Game Campaigns',
    // Own permission module since backend migration 1786900000000. This used
    // to be Voucher_or_Rewards_Management_Key, which meant voucher permission
    // also decided campaign access; the backend's URL-to-module map was
    // changed in the same release, so both sides now read the same module.
    id: APP_CONSTANTS.GAMIFICATION_TAG,
    to: APP_CONSTANTS.GAMIFICATION_CAMPAIGNS,
    active: false,
    key: APP_CONSTANTS.Gamification_Campaigns_Key,
    icon: MallIcon,
  },
  {
    title: 'App Settings',
    // Own permission module (backend migration 1787000000004, D-07). Must
    // be the LAST array element — the sidebar renders in array order.
    id: APP_CONSTANTS.APP_SETTINGS_TAG,
    to: APP_CONSTANTS.APP_SETTINGS,
    active: false,
    key: APP_CONSTANTS.App_Settings_Key,
    icon: userIcon,
  },
];

export default SideMenuData;
